//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CyclicType",1,0],[0,"IsForElecCam",1,0],[1,"MasterMaximum",0,"Expression",0],[1,"MasterMinimum",0,"Expression",0],[0,"MasterUnit",1,0],[0,"Name",1,0],[1,"SlaveMaximum",0,"Expression",0],[1,"SlaveMinimum",0,"Expression",0],[0,"SlaveUnit",1,0]],[[["part","name","masterPos","slavePos","vin","vout","ain","aout","vinEqVout","ainEqAout","constantSpeed"],"AddElement",{},11,0],[[],"ClearElements",{},0,0]],[]];
SPLM.Mechatronics.MotionProfileBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.MotionProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.MotionProfileBuilder.MasterValueUnit = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary", "Time" : "Time"});

SPLM.Mechatronics.MotionProfileBuilder.SlaveValueUnit = Object.freeze({
    "LinearPosition" : "LinearPosition", "RotaryPosition" : "RotaryPosition", "LinearSpeed" : "LinearSpeed", "RotarySpeed" : "RotarySpeed"});

SPLM.Mechatronics.MotionProfileBuilder.ProfileCyclicType = Object.freeze({
    "RelativeCyclic" : "RelativeCyclic", "Cyclic" : "Cyclic", "NonCyclic" : "NonCyclic"});

export default SPLM;